export const SET_SIDEBAR_WIDTH = 'SET_SIDEBAR_WIDTH';
export const SET_LAST_ADD_TO_SET_IDS = 'SET_LAST_ADD_TO_SET_IDS';
